import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { stages } from '../../submitting-an-investor-letter-of-intent.routes';
import { SubmittingAnInvestorLetterOfIntentForm } from './forms/submitting-an-investor-letter-of-intent.form';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { updateApplication } from '../../../../../../store/actions/application.actions';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-submitting-an-investor-letter-of-intent-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent
  ],
  providers: [SubmittingAnInvestorLetterOfIntentForm],
  templateUrl: './submitting-an-investor-letter-of-intent-section.component.html'
})
export class SubmittingAnInvestorLetterOfIntentSectionComponent implements OnDestroy {

  private store$: Store = inject(Store);

  private router: Router = inject(Router);

  private route: ActivatedRoute = inject(ActivatedRoute);

  public stages: string[] = stages;

  public form: SubmittingAnInvestorLetterOfIntentForm = inject(SubmittingAnInvestorLetterOfIntentForm);

  public applicationId: string = this.route.snapshot.params['appId'];

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.applicationId || '',
        application: this.form.value,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }

}
